import {
	GET_ORDER_QRCODES,
	GET_SHIPPERS,
	ORDER_LOADING,
} from '../actions/types';

const initState = {
	order_qr_codes: [],
	loading: false,
	shippers: [],
};

const order_qr_codeReducer = (state = initState, action) => {
	switch (action.type) {
		case GET_SHIPPERS:
			return {
				...state,
				shippers: action.payload,
			};
		case GET_ORDER_QRCODES:
			return {
				...state,
				order_qr_codes: action.order_qr_codes,
			};
		case ORDER_LOADING:
			return {
				...state,
				loading: action.payload,
			};
		default:
			return state;
	}
};

export default order_qr_codeReducer;
